<template>
  <div class="modal-mask">
    <div class="defend-wrap">
      <div class="defend-contents defend-type01 tac">
        <h1>결제수단 변경</h1>
        <span class="con-txt con-txt01">결제수단을 변경 하시겠어요?</span>
        <span class="icon-close" @click="clickClose()"><CloseButton/> </span>
        <div class="payment-method-change-txt">
            <span class="con-txt tal">
              결제수단을 변경하시더라도<br>
              <b>결제가 끊기거나 결제일이 변경되지 않으니</b><br>
              안심하고 변경하세요.<br>
              다음 결제일에 <b>변경하신 수단으로<br>
              자동 결제</b>됩니다.
            </span>
        </div>
        <span class="con-dotted con-txt02 tal">
            <i class="icon-dotted"></i>
            신용&lpar;체크&rpar;카드로 변경 가능한 점 참고해주세요.<br>
            ex) 휴대폰결제 등 기타 결제수단 &gt; 신용카드 , 신용카드 &gt; 신용카드
          </span>
        <div class="two-btn">
          <div class="ftl">
            <a @click.prevent="clickClose()" href="#" class="btn-cancel">취소</a>
          </div>
          <div class="ftr">
            <a @click.prevent="clickChangePayment()" href="#" class="btn-purple">결제수단 변경</a>
          </div>
        </div>
      </div><!--// defend-contents -->
    </div>
  </div>
</template>

<script>
import utils from '@/common/util/utils'
import { get } from 'lodash'
import CloseButton from '@/assets/svg/common/ic_gnb_close_w.svg'
import { PATH_NAME_SUBSCRIPTION_TICKET } from '@/common/router.const'

export default {
  name: 'PopupChangePayment',
  components: {
    CloseButton
  },
  data () {
    return {
      device: utils.cookies.getDevice(),
      transactionId: ''
    }
  },
  methods: {
    clickClose () {
      this.$router.back()
    },
    clickChangePayment () {
      let returnUrl = window.location.protocol + '//' + window.location.hostname + '/callback.html'
      if (this.device !== 'mobile') {
        try {
          const url = encodeURIComponent(`https://bill.wavve.com/ChangeMethod?credential=${utils.cookies.getCredential()}&transactionId=this.transactionId&returnUrl=${encodeURIComponent(returnUrl)}&deviceTypeId=${this.device}`)
          location.href = 'captvpooq://webview?url=' + url + '&external=y'
        } catch (err) {
          console.log(err)
        }
      } else {
        // TODO: 실섭에서 취소 버튼 눌러서 제대로 창이 닫히고 하는지 확인해봐야됨
        let popup = window.open('https://bill.wavve.com/ChangeMethod' +
            '?credential=' + encodeURIComponent(utils.cookies.getCredential()) +
            '&transactionId=' + this.transactionId +
            '&returnUrl=' + encodeURIComponent(returnUrl) +
            '&deviceTypeId=mobile',
        '_blank',
        'scrollbars=yes')
        popup.window.focus()
        this.$router.replace({ name: PATH_NAME_SUBSCRIPTION_TICKET })
      }
    }
  },
  created () {
    this.transactionId = get(this.$route, ['query', 'transationid'], '')
  }
}
</script>
<style lang="css" scoped>

  .icon-close {
    position: absolute;
    top: 12px;
    right: 12px;
  }

  .modal-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 5000;
  }

  .modal-mask .defend-wrap {
    width: 100%;
    /*min-height: 100%;*/
    min-height: 100vh;
  }

  /* 해지방어 */
  .defend-wrap {
    width: 100%;
    background-color: #000;
    position: relative;
  }

  .defend-wrap .defend-close {
    position: absolute;
    top: 0;
    right: 0;
  }

  .defend-wrap .defend-close > img {
    width: 36px;
  }

  .defend-wrap .defend-top {
    background: linear-gradient(45deg, #f76dac 0%, #ef6477 100%);
    background: -moz-linear-gradient(45deg, #f76dac 0%, #ef6477 100%);
    background: -webkit-linear-gradient(45deg, #f76dac 0%, #ef6477 100%);
    background: -o-linear-gradient(45deg, #f76dac 0%, #ef6477 100%);
    background: -ms-linear-gradient(45deg, #f76dac 0%, #ef6477 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f76dac', endColorstr='#ef6477', gradientType=1);
    color: #fff;
  }

  .defend-wrap .defend-info01 {
    padding: 30px 17px;
    text-align: center;
  }

  .defend-wrap .defend-info02 {
    padding: 4px 20px 9px;
  }

  .defend-wrap h1 {
    font-size: 20px;
    line-height: 29px;
    color: #fff;
    text-align: center;
  }

  .defend-wrap .defend-top > img {
    margin: 0 0 20px;
    width: 44px;
  }

  .defend-wrap .defend-top .coin-info {
    margin: 0 0 16px;
    width: 140px;
  }

  .defend-wrap .defend-top > p {
    font-size: 13px;
    line-height: 1.5;
    margin: 6px 0 0;
  }

  .defend-wrap:before {
    content: '';
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
  }

  .defend-wrap .defend-contents {
    position: absolute;
    top: 50%;
    left: 50%;
    /*margin-left: -157px;*/
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 315px;
    padding: 30px 20px;
    overflow: hidden;
    background-color: #252525;
  }

  @media all and (max-width: 320px) {
    .defend-wrap .defend-contents {
      /*margin-left: -145px;*/
      width: 290px;
    }
  }

  .defend-wrap .con-tit {
    font-size: 13px;
    font-weight: 700;
    margin: 0 0 10px;
    display: block;
    color: #23212a;
    line-height: 1.5;
  }

  .defend-wrap .con-dotted {
    display: block;
    font-size: 13px;
    line-height: 1.38;
    padding-left: 7px;
    text-indent: -7px;
    margin: 0 0 6px;
  }

  .defend-wrap .con-dotted i {
    display: inline-block;
    background: #717171;
    width: 2px;
    height: 2px;
    vertical-align: middle;
    margin-right: 4px;
    margin-left: 0;
  }

  .defend-wrap .con-dotted.pink-dotted em {
    background: #eb2e80;
  }

  .defend-wrap .con-txt {
    display: block;
    font-size: 12px;
    line-height: 18px;
    color: #a5a5a5;
  }

  .defend-wrap .con-txt01 {
    margin: 4px 0 20px;
    text-align: center;
  }

  .defend-wrap .con-txt02 {
    font-size: 12px;
    color: #717171;
    margin: 20px 0 0;
  }

  .defend-wrap .btn-pink {
    margin: 40px 0 20px;
  }

  .defend-wrap .btn-pink a {
    display: block;
    background: #f66ca7;
    width: 100%;
    border-radius: 100px;
    height: 45px;
    color: #fff;
    line-height: 44px;
    font-size: 13px;
    text-align: center;
  }

  .defend-wrap .gray-arrow {
    display: inline-block;
    font-size: 13px;
    color: #717171;
    padding-right: 13px;
    background-size: 12px;
  }

  .defend-wrap .reason-list li {
    margin: 0 0 8px;
  }

  .defend-wrap .reason-list li:first-child {
    padding: 10px 0 0;
  }

  .defend-wrap .reason-list li:last-child {
    padding: 0 0 10px;
  }

  .defend-wrap .reason-list li label {
    color: #23212a;
    font-size: 13px;
  }

  .defend-wrap .reason-list li textarea {
    border-radius: 6px;
    width: calc(100% - 2px);
    padding: 15px;
    font-weight: 700;
    font-size: 13px;
    border: 1px solid #e5e5e5;
  }

  .defend-wrap .reason-list li textarea:focus {
    border: 1px solid #f66ca7 !important;
  }

  .defend-wrap .ticket-table {
    border: 1px solid #e5e5e5;
    width: 100%;
    padding: 20px 20px 10px;
    font-size: 13px;
  }

  .defend-wrap .ticket-table table{
    width: 100%;
    table-layout: fixed;
  }

  .defend-wrap .ticket-table td {
    vertical-align: top;
    line-height: 1.54;
    padding-left: 20px;
  }

  .defend-wrap .ticket-table td:first-child {
    padding: 0 0 10px 0;
  }

  .defend-wrap .marB0 {
    margin-bottom: 0;
  }

  .defend-wrap .marT30 {
    margin-top: 30px;
  }

  .defend-wrap .gray-back {
    padding: 20px;
    background-color: #2f2f2f;
    border-radius: 4px;
  }

  .defend-wrap .payment-method-change-txt{
    padding: 20px;
    border: 1px solid #2f2f2f;
  }

  .defend-wrap .two-btn {
    display: flex;
    justify-content: space-between;
    width: 100%;
    overflow: hidden;
    margin: 20px 0 0;
  }

  .defend-wrap .two-btn > div {
    flex: 1;
  }

  .defend-wrap .two-btn .ftl{
    padding-right: 2.5px;
  }

  .defend-wrap .two-btn .ftr{
    padding-left: 2.5px;
  }

  .defend-wrap .btn-line,
  .defend-wrap .btn-purple,
  .defend-wrap .btn-cancel{
    display: block;
    width: 100%;
    height: 36px;
    border: 1px transparent solid;
    border-radius: 100px;
    font-size: 14px;
    line-height: 34px;
    text-align: center;
  }

  @media all and (max-width: 320px) {
    .defend-wrap .btn-line,
    .defend-wrap .btn-purple,
    .defend-wrap .btn-cancel{
      font-size: 12px;
    }
  }

  .defend-wrap .btn-line {
    border-color: #ccc;
    color: #fff;
  }

  .defend-wrap .btn-cancel {
    color: #fff;
    background-color: #717171;
  }
  .defend-wrap .btn-purple {
    background-color: #1351f9;
    border-color: #1351f9;
    color: #fff;
  }

  .defend-wrap .fc-pink {
    color: #eb2e80;
  }
</style>
